var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYorbitBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 262.58 226.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #7810ee;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -705,
    y: -5,
    width: 280,
    height: 241
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.51,70.2c-4.68-16.94-33.09-24.98-71.18-22.75-12.73-8.11-27.94-12.63-44.17-12.16-43.08,1.26-76.98,37.2-75.72,80.28,1.26,43.08,37.2,76.98,80.28,75.72,40.69-1.19,73.17-33.32,75.6-73.18,25.11-15.81,39.18-33.5,35.2-47.91h0ZM57.04,119.31c-2.29-32.59,23.25-60.85,57.02-63.12,26.05-1.75,49.39,12.47,59.76,34.02-16.11,9.03-38.17,17.9-63.14,24.79-19.03,5.25-37.19,8.63-52.93,10.18-.33-1.92-.58-3.88-.72-5.86h.01ZM121.97,174.38c-18.32,1.23-35.31-5.41-47.42-16.94,14.24-1.73,29.41-4.68,44.97-8.98,22.06-6.09,42.12-14.05,58.88-22.91-4.87,26.2-27.67,46.89-56.42,48.83h-.01ZM185.72,83.87c-5.07-12.46-13.27-23.28-23.59-31.53,21.26-.71,35.82,2.87,38,10.75,1.62,5.85-3.86,13.18-14.41,20.78Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYorbitBranco);
export default __webpack_public_path__ + "static/media/yorbit-branco.98ffa35eb639387ccdd0c49085d06582.svg";
export { ForwardRef as ReactComponent };